import Component from 'vue-class-component'
import IconButton from '@/components/buttons/richmenu/IconButton';

@Component({
  name: 'number-list-button',
})
export default class NumberListButton extends IconButton {
}
